<template lang='pug'>
  .fpui-stars
    i.fpui-star.fa.fa-star(:class='{active: idx <= value}', v-for='idx in range')
</template>

<script>

export default {
  props: {
    value: { type: Number, required: true }
  },
  data () {
    return {
      range: 5
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";
.fpui-stars {
  .fpui-star {
    display: inline-block;
    width:30px;
    height:30px;
    font-size:30px;
    margin:10px 2px;
    color:#eee;
    &.active {
      color:@yellow;
    }
  }
}
</style>
